<template>
<div class="chapter">
<div class="inner_page">
<h1>Pieces of Eight</h1>
<h3 class="sigil_not_in_toc"><i>Time Trap: Book Three</i></h3>
<h2 class="sigil_not_in_toc" style="text-align: center;">Deborah Chester</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_title.vue?0b01dcb2